import React from 'react';
import './Footer.css';
import Button from '@mui/material/Button';
import { Divider, IconButton } from '@mui/material';
import AegleDivider from './AegleDivider';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { useNavigate } from 'react-router-dom';

const Footer: React.FC = () => {
    const navigate = useNavigate();

    const handleNavigation = (path: string) => {
        navigate(path);
        window.scrollTo(0, 0);
    }

    return (
        <div className="Footer">
            {/* Footer Section */}
            <footer className="footer-section">
                <h2>ADAPTIVE CAPITAL <i>for</i> HEALTHCARE</h2>
                <a href="https://www.linkedin.com/company/aegle-cap/" target="_blank" rel="noopener noreferrer">
                    <IconButton
                        size="large"
                        sx={{
                            color: 'white',
                            fontSize: '3rem',
                            width: '80px',
                            height: '80px',
                        }}
                    >
                        <LinkedInIcon fontSize="inherit" />
                    </IconButton>
                </a>
                <img src="/LogoReverse.svg" alt="Logo" className="footer-logo" />
                <p>&copy; 2026 Aegle Capital. All Rights Reserved.</p>
                <p className="footer-fineprint">
                    Aegle Capital is a registered trade name (d/b/a) of Aegle Health Partners, Inc.
                    <br />
                    708 N 1st St, Ste 342, Minneapolis, MN 55401 &middot; <a href="mailto:info@aeglecap.com">info@aeglecap.com</a>
                </p>

                <nav className="footer-nav">
                    <div className="footer-site">
                        <a href="/">HOME</a>
                        <a href="/accel" onClick={(e) => { e.preventDefault(); handleNavigation('/accel'); }} >ACCEL</a>
                        <a href="/about" onClick={(e) => { e.preventDefault(); handleNavigation('/about'); }} >COMPANY</a>
                        <a href="/news" onClick={(e) => { e.preventDefault(); handleNavigation('/news'); }} >NEWS</a>
                        <a href="/contact" onClick={(e) => { e.preventDefault(); handleNavigation('/contact'); }} >CONTACT</a>
                    </div>
                </nav>
            </footer>
        </div>
    );
}
export default Footer;
